import { resolve, join } from 'node:path';
import { pathExists } from '@wix/cli-fs';
import { copyFile, mkdir } from 'node:fs/promises';
import type { AssetsGeneratorOptions } from './types.js';
import { getFiles } from './fs-extra.js';

export async function assetsGenerator(opts: AssetsGeneratorOptions) {
  const { templateRoot, projectFolder, outputPath, assetsPrefix } = opts;

  const assets = join(templateRoot, 'assets');

  if (await pathExists(assets)) {
    const publicDir = join(projectFolder, outputPath ?? '');
    const publicFiles = await getFiles(assets);

    await mkdir(publicDir, { recursive: true });

    await Promise.all(
      publicFiles.map(async (file) => {
        const outputName = assetsPrefix ? `${assetsPrefix}-${file}` : file;
        const from = resolve(assets, file);
        const to = resolve(publicDir, outputName);
        await copyFile(from, to);
      })
    );
  }
}
